import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { getPinnedParticipant } from '../base/participants/functions';
let isRunning = false;
let storeInstance = null;
/**
 * Middleware that automatically pins the participant named "Client" by
 * simulating a click on their DOM element. This runs continuously to ensure
 * the participant stays pinned even if the dominant speaker changes.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register((store) => next => action => {
    const result = next(action);
    // Store the store instance for later use
    storeInstance = store;
    switch (action.type) {
        case CONFERENCE_JOINED: {
            // Wait for DOM to be fully rendered
            if (document.readyState === 'complete') {
                startOperatorPinning();
            }
            else {
                window.addEventListener('load', () => {
                    startOperatorPinning();
                });
            }
            break;
        }
    }
    return result;
});
/**
 * Starts a continuous loop using requestAnimationFrame that checks and pins the Client.
 * This runs ~60 times per second for instant reaction.
 */
function startOperatorPinning() {
    if (isRunning) {
        return; // Already running
    }
    isRunning = true;
    console.log('[ClientFocus] Starting continuous Client pinning loop...');
    // Continuous loop using requestAnimationFrame
    function pinningLoop() {
        if (isRunning) {
            pinOperatorByClick();
            requestAnimationFrame(pinningLoop);
        }
    }
    pinningLoop();
}
let lastLogTime = 0;
/**
 * Checks if the operator is currently pinned by checking Redux state.
 */
function isOperatorPinned(operatorId) {
    if (!storeInstance) {
        return false;
    }
    const state = storeInstance.getState();
    const pinnedParticipant = getPinnedParticipant(state);
    // Extract just the participant ID from the full ID format
    // participantId format: "participant_347e551f"
    // We need to extract: "347e551f"
    const shortOperatorId = operatorId.replace('participant_', '');
    return pinnedParticipant?.id === shortOperatorId;
}
/**
 * Finds and clicks on the "Client" participant element to pin them.
 * This simulates a manual user action.
 */
function pinOperatorByClick() {
    const participantId = getParticipantIdByName('Client');
    if (participantId) {
        const el = document.getElementById(participantId);
        if (el) {
            const isPinned = isOperatorPinned(participantId);
            // Log status occasionally (every 2 seconds) to avoid console spam
            const now = Date.now();
            if (now - lastLogTime > 2000) {
                console.log('[ClientFocus] Client status - ID:', participantId, 'Pinned:', isPinned);
                lastLogTime = now;
            }
            // Only click if NOT pinned
            if (!isPinned) {
                console.log('[ClientFocus] Client NOT pinned. Clicking to pin:', participantId);
                el.click();
            }
        }
    }
}
/**
 * Finds a participant's ID by their display name.
 * Matches any participant whose name starts with the given prefix.
 *
 * @param {string} namePrefix - The display name prefix to search for (e.g., "Client").
 * @returns {string|null} The participant's DOM ID or null if not found.
 */
function getParticipantIdByName(namePrefix) {
    const nameSpans = document.querySelectorAll('span.displayname');
    // Convert NodeList to Array to iterate
    for (let i = 0; i < nameSpans.length; i++) {
        const span = nameSpans[i];
        const participantName = span.textContent?.trim();
        if (participantName && participantName.startsWith(namePrefix)) {
            // span.id has format "participant_36c2a3b4_name"
            return span.id.replace('_name', '');
        }
    }
    return null;
}
